module.exports = __webpack_public_path__ + "img/tooltip_03-VALLONE_MURALE_EDGE_DOPPIO_C00822_C.847d26e0.jpg";